//variable to select the multiple items in cart
cartSelectCounter = 0;
selectCartItemsArr = [];
const CART_MOBILE_MAX_WIDTH = 768;
const CART_TABLET_MIN_WIDTH = 768;
const CART_DESKTOP_MIN_WIDTH = 769;
const CART_LARGE_DESKTOP_MIN_WIDTH = 770;
const CART_NARROW_MOBILE_MAX_WIDTH = 419;
const isCartMobileViewport = window.matchMedia(`(max-width: ${CART_MOBILE_MAX_WIDTH}px)`).matches;
const isCartTabletOrDesktopViewport = window.matchMedia(`(min-width: ${CART_TABLET_MIN_WIDTH}px)`).matches;
const isCartDesktopViewport = window.matchMedia(`(min-width: ${CART_DESKTOP_MIN_WIDTH}px)`).matches;
const isCartLargeDesktopViewport = window.matchMedia(`(min-width: ${CART_LARGE_DESKTOP_MIN_WIDTH}px)`).matches;
const isCartNarrowMobileViewport = window.matchMedia(`(max-width: ${CART_NARROW_MOBILE_MAX_WIDTH}px)`).matches;

function replaceCartDrawerContent(newDrawer, afterRender) {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer || !newDrawer) return;

  // Replace the drawer in one frame-scheduled DOM write to reduce cart reflow invalidations.
  requestAnimationFrame(() => {
    cartDrawer.replaceChildren(newDrawer);
    afterRender?.();
  });
}

function updateCart() {
  fetch(`/pages/homepage-2/?section_id=cart-drawer`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');

      cartSelectCounter = 0;

      //enable smartbuy logic
      if (getCookieVal('utmsource_smartbuy') != null) {
        if (html.documentElement.querySelector('.cart__gift-voucher')) {
          html.documentElement.querySelector('.cart__gift-voucher').style.display = 'none';
        }
        html.querySelectorAll('.jw-cart-wallet-credits').forEach((element) => {
          element.style.display = 'none';
        });
      }

      replaceCartDrawerContent(html.documentElement.querySelector('#CartDrawer'), () => {
        const allItems = document.querySelectorAll('.cart-item');
        const cartCount = document.querySelector('.cart-count-bubble .cart-item__count');
        const cartForm = document.querySelector('#CartDrawer-Form');
        const drawerHeader = document.querySelector('.drawer__header');
        const cartCtas = document.querySelector('.cart__ctas');
        let sum = 0;
        cartTotal = parseInt(document.querySelector('[data-totalprice]').getAttribute('data-totalprice'));

        if (allItems.length > 0) {
          allItems.forEach((item) => {
            let itemCount = Number(item.querySelector('.custom-select-selected').getAttribute('value'));
            sum += itemCount;
          });
          // Cache DOM lookups before applying styles to avoid repeated document queries during cart refresh.
          if (cartCount) cartCount.innerText = sum;
          if (cartForm) cartForm.style.display = 'block';
          if (drawerHeader) {
            drawerHeader.style.display = 'flex';
            drawerHeader.style.width = '100%';
          }
          if (cartCtas) cartCtas.style.transform = 'translate(0%)';
        } else {
          if (cartForm) cartForm.style.display = 'none';
        }
        if (typeof window.jwHandleCartDrawerRender === "function") {
          window.jwHandleCartDrawerRender();
        }
      });
    });
}

document.addEventListener('DOMContentLoaded', updateCart, { once:true })

function closeAllSelect(elmnt) {
  const selects = document.getElementsByClassName('custom-select');
  for (let i = 0; i < selects.length; i++) {
    const select = selects[i];
    const items = select.getElementsByClassName('select-items');
    const selected = select.getElementsByClassName('select-selected');
    // if (event.target !== selected[0] && event.target.parentNode !== selected[0]) {
    //    //items[0].style.display = "none";
    // }
  }
}

function deleteItem(event) {
  let dataId = event.getAttribute('data-delete-variant-id');
  let loaderParnet = event.parentElement;
  let loader = loaderParnet.querySelector('.loading-overlay');
  loader.classList.remove('hidden');
  let removeBtnTd = event.parentElement.parentElement.parentElement.querySelector('.custom-cart-item__quantity');
  let removeBtn = removeBtnTd.querySelector('.removeBtnCart');
  removeBtn.click();
  if (typeof updateDeletedVariants == 'function') {
    updateDeletedVariants(dataId);
  }
  let allDelete = document.querySelectorAll('.custom-delete-cart');
  if (allDelete) {
    allDelete.forEach((deleteBtn) => {
      deleteBtn.style.pointerEvents = 'none';
    });
  }

  fetchCardDetails();

  if (isCartDesktopViewport) {
    setTimeout(() => {
      showCartRecommendations();
    }, '2000');
  }

  cartSelectCounter = 0;
  selectCartItemsArr.length = 0;
}

function selectItems(event) {
  let eventTd = event.closest('.custom-cart-item__media').parentElement;
  let targetTd = eventTd.querySelector('.custom-cart-item__quantity');
  let plus = targetTd.querySelector("button[name='plus']");
  let minus = targetTd.querySelector("button[name='minus']");
  let qty = targetTd.querySelector('input');
  let selectedOption = event.innerHTML;
  let select = event.parentElement.previousElementSibling;
  select.innerHTML = `${selectedOption} <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
<g id="np_right_5203532_000000 2">
<g id="Group">
<path id="Vector" d="M8.04118 11.4902C7.74528 11.1836 7.75015 10.6963 8.05094 10.3945C8.35269 10.0938 8.83999 10.0889 9.14664 10.3848L12.5001 13.7393L15.8536 10.3858L15.8536 10.3848C15.9991 10.2344 16.1993 10.1485 16.4093 10.1465C16.6183 10.1446 16.8204 10.2276 16.9689 10.375C17.1164 10.5235 17.1994 10.7256 17.1974 10.9346C17.1955 11.1446 17.1095 11.3448 16.9591 11.4903L13.0529 15.3965C12.7472 15.7012 12.2531 15.7012 11.9474 15.3965L8.04118 11.4902Z" fill="black"/>
</g>
</g>
</svg>`;
  if (qty.value > selectedOption) {
    let diff = qty.value - selectedOption;
    for (let i = 0; i < diff; i++) {
      minus.click();
    }
  } else if (qty.value < selectedOption) {
    let diff = selectedOption - qty.value;
    for (let i = 0; i < diff; i++) {
      plus.click();
    }
  }
  select.classList.add('selected');
  closeAllSelect(this);
}

function cartCustomQtyFunction(event) {
  document.querySelectorAll('.custom-select').forEach((item) => {
    if (item !== event) {
      item.classList.remove('addDisplay');
    }
  });
  closeAllSelect(this);
  event.classList.toggle('addDisplay');
}

function closeAllCustomCartQty() {
  let qtySelect = document.querySelectorAll('.custom-select');
  qtySelect.forEach((select) => {
    if (select.classList.contains('addDisplay')) select.classList.remove('addDisplay');
  });
}

function custom_CartVariantFunction(event) {
  event.querySelector('.custom_VariantSelect').classList.toggle('show_Variants');
}

function closeAll_CustomCartVariant() {
  document.querySelectorAll('.custom_VariantSelect').forEach((e) => {
    e.classList.remove('show_Variants');
  });
}

async function updateCartVariant(
  cartVariant_Id,
  cartVariant_Quantity,
  cartVariant_OptionId,
  cartVariant_OptionQtyAvailable,
  cartProductId,
  event
) {
  // To Check whether the same variant exists in cart
  let allCartVariantsArray = [];
  let clickedVariantId = Number(event.getAttribute('cartvariant_optionid'));
  let isVariantAvailable;
  let clickedVariantText = event.querySelector('p').textContent.trim();
  let allItems = document.querySelectorAll('[data-id="custom-cart-item"]');

  document.querySelectorAll('[data-SelectedVariantId]').forEach((e) => {
    allCartVariantsArray.push(Number(e.getAttribute('data-SelectedVariantId')));
  });

  allCartVariantsArray.forEach((e) => {
    if (e == clickedVariantId) {
      isVariantAvailable = true;
    }
  });

  if (isVariantAvailable == true) {
    //To display the message that current variant is added in the cart
    event.closest('.custom-cart-item__media-div2').querySelector('.variantsAvailableText').style.display =
      'inline-flex';
    setTimeout(() => {
      event.closest('.custom-cart-item__media-div2').querySelector('.variantsAvailableText').style.display = 'none';
    }, 5000);
  } else {
    event
      .closest('.custom-cart-size-qty')
      .querySelector('cart-drawer-items .loading-overlay')
      .classList.remove('hidden');
    //To delete the current variant in the cart
    await deleteCartVariant(cartVariant_Id);

    //To add the selected variant in the cart
    await addCartVariant(cartVariant_Quantity, cartVariant_OptionId, cartVariant_OptionQtyAvailable, event);

    //This function renders the cart.
    await updatePackCart();

    //To hide the loader after the adding the new variant
    event.closest('.custom-cart-size-qty').querySelector('cart-drawer-items .loading-overlay').classList.add('hidden');

    if (isCartDesktopViewport) {
      setTimeout(() => {
        showCartRecommendations();
      }, 2000);
    }

    //The Global Object of Product Page has to updated so that it synchronizes with the changes done in the Cart by Variant Change
    cartTemplate = document.querySelector('[cartTemplate]').getAttribute('cartTemplate');

    if (cartTemplate == 'product') {
      variantsArr.forEach((z) => {
        if (z.id == cartVariant_Id) {
          z.cartQty = '0';
        }

        if (z.id == cartVariant_OptionId) {
          let productVarUpdateQty;
          if (cartVariant_OptionQtyAvailable >= cartVariant_Quantity) {
            productVarUpdateQty = cartVariant_Quantity;
            z.cartQty = productVarUpdateQty.toString();
          } else {
            productVarUpdateQty = cartVariant_OptionQtyAvailable;
            z.cartQty = productVarUpdateQty.toString();
          }
        }
      });
    }

    if (typeof updateCartGtm === 'function') {
      allItems.forEach((item) => {
        let itemProductId = item.getAttribute("cart-product-id");

        if (itemProductId === String(cartProductId)) {
          let gtmProductInfo = item.getAttribute("data-gtm-product-info");

          if (gtmProductInfo) {
            try {
              let productData = JSON.parse(gtmProductInfo);
              if (productData != null) {
                productData.size_variant = clickedVariantText; // Update size_variant
                let updatedGtmProductInfo = JSON.stringify(productData);
                item.setAttribute(
                  "data-gtm-product-info",
                  updatedGtmProductInfo
                );
                updateCartGtm("size_change", productData);
              }
            } catch (error) {
              console.error("Error parsing GTM Product Info:", error);
            }
          }
        }
      });
    }

    //To update the quantity and add to cart button
    let checkedVariantLabel = document.querySelector(".variant_innerWrapper input[type=radio]:checked+label");
    if(checkedVariantLabel) checkedVariantLabel.click();
  }
}

async function deleteCartVariant(cartVariant_Id) {
  let variantBody = {
    updates: {
      [cartVariant_Id]: 0,
    },
  };

  let requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify(variantBody),
  };

  try {
    let response = await fetch('/cart/update.js', requestOptions);
    let result = await response.json;
    return result;
  } catch (err) {
    throw err;
  }
}

async function addCartVariant(cartVariant_Quantity, cartVariant_OptionId, cartVariant_OptionQtyAvailable, event) {
  let variantQuantity;
  if (cartVariant_OptionQtyAvailable >= cartVariant_Quantity) {
    variantQuantity = cartVariant_Quantity;
  } else {
    variantQuantity = cartVariant_OptionQtyAvailable;
    event
      .closest('.custom-cart-item__media-div2')
      .querySelector('.variantsAvailableText').innerText = `Only ${variantQuantity} available `;
    event.closest('.custom-cart-item__media-div2').querySelector('.variantsAvailableText').style.display =
      'inline-block';
    setTimeout(() => {
      event.closest('.custom-cart-item__media-div2').querySelector('.variantsAvailableText').style.display = 'none';
    }, 3000);
  }

  let requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify({
      items: [
        {
          id: cartVariant_OptionId,
          quantity: variantQuantity,
        },
      ],
    }),
  };

  try {
    let response = await fetch('/cart/add.js', requestOptions);
    let result = await response.json;
    return result;
  } catch (err) {
    throw err;
  }
}

async function addCartPack(packProdId, packProdQuant, packProdPrice, mainProdId, addBtn) {
  const cartClose = document.querySelector('.custom-drawer__close');
  const cartTotal = parseInt(document.querySelector('[data-totalprice]').getAttribute('data-totalprice'));
  let totalCartAmount = cartTotal + parseInt(packProdPrice);
  event.preventDefault();

  // Reference to the loading overlay
  const loadingOverlay = document.querySelector(`.cart-pack-loading-overlay[data-variant-id="${packProdId}"]`);

  // Show the loading overlay
  loadingOverlay.classList.remove('hidden');

  if (totalCartAmount <= 49999) {
    try {
      let response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: packProdId,
              quantity: packProdQuant,
            },
          ],
        }),
      });

      if (!response.ok) {
        console.error('Failed to add product pack to cart');
      }

      let data = await response.json();

      const updateData = {
        updates: {
          [mainProdId]: 0,
        },
      };

      response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateData),
      });

      if (!response.ok) {
        console.error('Failed to remove main product from cart');
      }

      data = await response.json();

      if (isCartDesktopViewport) {
        setTimeout(() => {
          showCartRecommendations();
        }, 2000);
      }
      updatePackCart(addBtn, packProdId, data);
      updateDeletedVariants(mainProdId);
      productMsg();
    } catch (error) {
      console.error('Error updating the cart:', error);
    }
  } else {
    // Hide the loading overlay
    loadingOverlay.classList.add('hidden');
    orderValueExceededMsg();
    closeAllCustomCartQty();
    if (typeof closeCartRecommendations === 'function') closeCartRecommendations();
    document.querySelector('cart-drawer')?.close();
  }
}

function updateGtmForMatchingItems({ matchCondition, eventName, itemCount, cartTotal }) {
  if (typeof updateCartGtm !== 'function') return;
  const allItems = document.querySelectorAll('[data-id="custom-cart-item"]');

  allItems.forEach((item) => {
    const itemId = item.getAttribute('cart-variant-id');

    if (matchCondition(itemId)) {
      const gtmProductInfo = item.getAttribute('data-gtm-product-info');

      if (gtmProductInfo) {
        try {
          const productData = JSON.parse(gtmProductInfo);
          const cart_line_items_count = itemCount;
          const cart_total_amount = Number.parseFloat(cartTotal) || 0;
          // prqt: this line item's quantity in the cart drawer (custom qty selector or updates[] input)
          const prqtRaw =
            item.querySelector('.custom-select-selected')?.getAttribute('value') ??
            item.querySelector('input[name="updates[]"]')?.value ??
            item.querySelector('input')?.value ??
            0;
          const prqt = Number(prqtRaw) || 1;
          item.setAttribute('data-gtm-product-info', JSON.stringify(productData));

          if (itemCount != null && cartTotal != null && productData) {
            updateCartGtm(eventName, { cart_line_items_count, cart_total_amount, prqt, ...productData });
          }
        } catch (error) {
          console.error("Error parsing GTM Product Info:", error);
        }
      }
    }
  });
} 

function updatePackCart(addBtn, packProdId, data) {
  fetch(`${routes.cart_url}?section_id=cart-drawer`)
    .then((data) => data.text())
    .then((result) => {
      const parser = new DOMParser();
      const htmlString = `${result}`;
      const doc3 = parser.parseFromString(htmlString, 'text/html');

      // enable smartbuy logic
      if (getCookieVal('utmsource_smartbuy') != null) {
        if (doc3.documentElement.querySelector('.cart__gift-voucher')) {
          doc3.documentElement.querySelector('.cart__gift-voucher').style.display = 'none';
        }
        doc3.querySelectorAll('.jw-cart-wallet-credits').forEach((element) => {
          element.style.display = 'none';
        });
      }

      replaceCartDrawerContent(doc3.documentElement.querySelector('#CartDrawer'), () => {
        const cartProductItem = document.querySelectorAll('.cart-item');
        let sum = 0;
        if (document.querySelectorAll('.cart-items').length > 0) {
          cartProductItem.forEach(function (cartItem) {
            const selectSelectedElements = cartItem.querySelectorAll('.custom-select-selected');
            selectSelectedElements.forEach(function (selectSelected) {
              const value = parseInt(selectSelected.getAttribute('value'));
              if (!isNaN(value) && value > 0) {
                sum += value;
              }
            });
          });
          document.querySelector('.cart-count-bubble .cart-item__count').innerText = sum;
          document.querySelector('#CartDrawer-Form').style.display = 'block';
          document.querySelector('.drawer__header').style.display = 'flex';
          document.querySelector('.drawer__header').style.width = '100%';
          document.querySelector('.cart__ctas').style.transform = 'translate(0%)';
          if ( typeof updateGtmForMatchingItems === 'function' && data && packProdId != null ) {
            updateGtmForMatchingItems({
              matchCondition: (itemId) => String(packProdId) === itemId,
              eventName: "replace_with_packs",
              itemCount: data.item_count,
              cartTotal: (data.total_price / 100).toFixed(2)
            });
          }
        } else {
          document.querySelector('#CartDrawer-Form').style.display = 'none';
          document.querySelector('.cart-count-bubble .cart-item__count').innerText = 0;
        }
      });
    });
    
    fetchCart("nitroUpdatingCart");
    cartSelectCounter = 0;
}

function closeCartRecommendations() {
  if (isCartDesktopViewport) {
    const cartDrawerRecommendation = document.querySelector('.cart-drawer--recommendations--container');
    if (!cartDrawerRecommendation) return;
    cartDrawerRecommendation.style.transform = 'translate(0)';
  }
}

function showCartRecommendations() {
  const cartItems = document.querySelector('.custom-cart-tableBody');
  const cartDrawerRecommendation = document.querySelector('.cart-drawer--recommendations--container');
  if (cartItems) {
    if (cartDrawerRecommendation) {
      cartDrawerRecommendation.style.transform = 'translate(-95%)';
    }
  } else {
    if (cartDrawerRecommendation) {
      cartDrawerRecommendation.style.transform = 'translate(0)';
    }
  }
}

// Track clicks on recommended products in cart drawer for analytics
function recommendedProductClick(element) {
  if (typeof updateCartGtm !== 'function') return;
  
  // Find the product card container
  const productCard = element.closest('.new_card_product_content');
  if (!productCard) return;
  
  // Get GTM product info from the wishlist button
  const wishlistButton = productCard.querySelector('[data-gtm-product-info]');
  const gtmProductInfo = wishlistButton?.getAttribute('data-gtm-product-info');
  
  // Get price and product ID from the price container
  const priceContainer = productCard.querySelector(".price__container");
  const purl = window.location.href;
  const price = Number(priceContainer?.getAttribute("data-price")) || 0;
  const prid = Number(priceContainer?.getAttribute("data-proid")) || 0;

  if (gtmProductInfo) {
    try {
      let productData = JSON.parse(gtmProductInfo);

      if (productData != null) {
        updateCartGtm("product_click", { purl, price, prid, ...productData });
      }
    } catch (error) {
      console.error("Error parsing GTM Product Info:", error);
    }
  }
}

if (isCartDesktopViewport) {
  const customCartIcon = document.querySelector('.custom-cart__icon');
  if (customCartIcon) {
    customCartIcon.addEventListener('click', showCartRecommendations);
  }
}

function cartIconSelect(event) {
  let iconSelect = document.querySelector('.selectIcon_Heading  .icon-select-span');
  let iconSelect_Active = document.querySelector('.selectIcon_Heading  .icon-select-active-span');
  let iconSelectAll_Active = document.querySelector('.selectIcon_Heading  .icon-selectAll-active-span');
  const cartItemCount = parseInt(document.querySelector('[data-cartItemCount]').getAttribute('data-cartItemCount'));
  let selectedItemVariantId = event.closest('data-selectId');

  if (event.classList.contains('selected')) {
    event.classList.remove('selected');
    //  event.closest('.cart-item.custom-cart-item').style.border = "1px solid #221f201a";
    event.closest('.cart-item.custom-cart-item').classList.remove('selected');
    cartSelectCounter--;

    if (cartSelectCounter == 0) {
      document.querySelector('.itemSelect_CountSpan').classList.add('hidden');
      event.closest('.drawer__cart-items-wrapper').querySelector('.select_CartItems').classList.remove('active');

      iconSelect.style.display = 'block';
      iconSelectAll_Active.style.display = 'none';
      iconSelect_Active.style.display = 'none';
    } else {
      event.closest('.drawer__cart-items-wrapper').querySelector('.select_CartItems').classList.add('active');

      if (cartItemCount > cartSelectCounter) {
        iconSelect_Active.style.display = 'block';
        iconSelectAll_Active.style.display = 'none';
      } else {
        iconSelect_Active.style.display = 'none';
        iconSelectAll_Active.style.display = 'block';
      }

      document.querySelector('.itemSelect_CountSpan').classList.remove('hidden');
    }

    let selectItemVariantId = event.closest('.custom-cart-item').getAttribute('cart-variant-id');

    selectCartItemsArr = selectCartItemsArr.filter((num) => num != selectItemVariantId);
  } else {
    event.classList.add('selected');
    event.closest('.drawer__cart-items-wrapper').querySelector('.select_CartItems').classList.add('active');
    //  event.closest('.cart-item.custom-cart-item').style.border = "1px solid #221F20";
    event.closest('.cart-item.custom-cart-item').classList.add('selected');

    cartSelectCounter++;
    document.querySelector('.itemSelect_CountSpan').classList.remove('hidden');

    if (cartItemCount > cartSelectCounter) {
      iconSelect.style.display = 'none';
      iconSelect_Active.style.display = 'block';
    } else {
      iconSelect.style.display = 'none';
      iconSelect_Active.style.display = 'none';
      iconSelectAll_Active.style.display = 'block';
    }

    let selectedItemVariantId = event.closest('.custom-cart-item').getAttribute('cart-variant-id');
    selectCartItemsArr.push(selectedItemVariantId);
  }

  document.querySelector('.itemSelect_Count').innerHTML = cartSelectCounter;
}

function selectAll_Items(event) {
  let iconSelect = document.querySelector('.selectIcon_Heading  .icon-select-span');
  let iconSelect_Active = document.querySelector('.selectIcon_Heading  .icon-select-active-span');
  let iconSelectAll_Active = document.querySelector('.selectIcon_Heading  .icon-selectAll-active-span');
  let cartItemCount = parseInt(document.querySelector('[data-cartItemCount]').getAttribute('data-cartItemCount'));

  // event.closest(".select_CartItems").classList.add('active');

  event.closest('.select_CartItems').classList.add('active');

  iconSelect.style.display = 'none';
  iconSelect_Active.style.display = 'none';
  iconSelectAll_Active.style.display = 'block';

  cartSelectCounter = cartItemCount;
  document.querySelector('.itemSelect_Count').innerHTML = cartItemCount;
  document.querySelector('.itemSelect_CountSpan').classList.remove('hidden');

  document.querySelectorAll('.cart-item.custom-cart-item').forEach((e) => {
    e.classList.add('selected');
  });

  document.querySelectorAll('.cartItem_SelectIcon').forEach((e) => {
    e.classList.add('selected');
  });

  document.querySelectorAll('[cart-variant-id]').forEach((e) => {
    selectCartItemsArr.push(e.getAttribute('cart-variant-id'));
  });
}

function deSelectAll_CartItems(event) {
  let iconSelect = document.querySelector('.selectIcon_Heading  .icon-select-span');
  let iconSelect_Active = document.querySelector('.selectIcon_Heading  .icon-select-active-span');
  let iconSelectAll_Active = document.querySelector('.selectIcon_Heading  .icon-selectAll-active-span');

  let cartItemCount = parseInt(document.querySelector('[data-cartItemCount]').getAttribute('data-cartItemCount'));

  event.closest('.select_CartItems').classList.remove('active');

  iconSelect.style.display = 'block';
  iconSelect_Active.style.display = 'none';
  iconSelectAll_Active.style.display = 'none';

  cartSelectCounter = 0;
  document.querySelector('.itemSelect_CountSpan').classList.add('hidden');

  document.querySelectorAll('.cart-item.custom-cart-item').forEach((e) => {
    e.classList.remove('selected');
  });

  document.querySelectorAll('.cartItem_SelectIcon').forEach((e) => {
    e.classList.remove('selected');
  });

  selectCartItemsArr.length = 0;
}

function delCartItems_Modal() {
  if( isCartMobileViewport &&  document.querySelector('cart-drawer.drawer.active') ){
    document.querySelector('.overlayDiv').style.display = 'block';
    document.querySelector('.wishlistDelete_MobModal').style.transform = 'translateY(0vh)';
    document.querySelector('.cartDeleteCount').innerHTML = cartSelectCounter;
  }
  else{
      document.querySelector('.overlayDiv_Desk').style.display = 'block';
      document.querySelector('cart-drawer').classList.remove('active');
      if( !document.querySelector('cart-drawer.drawer.active') && isCartNarrowMobileViewport ){
        document.querySelector('.wishlistDelete_DeskModal').style.width = "90%";
      }
      document.querySelector('.wishlistDelete_DeskModal').style.display = 'grid';
      document.querySelector('.cartDeleteCountD').innerHTML = cartSelectCounter;
  }
}

function wishlistCartItems_Modal(event) {
  if (isCartMobileViewport) {
    document.querySelector('.overlayDiv').style.display = 'block';
    document.querySelector('.wishlistDelete_MobModal').style.transform = 'translateY(0vh)';
    document.querySelector('.wishlistDelete_MobModal').classList.add('wishlistMobModal');
    document.querySelector('.cartWishlistCount').innerHTML = cartSelectCounter;
  } else {
    document.querySelector('cart-drawer').classList.remove('active');
    document.querySelector('.wishlistDelete_DeskModal').classList.add('wishlistDeskModal');
    document.querySelector('.overlayDiv_Desk').style.display = 'block';
    document.querySelector('.wishlistDelete_DeskModal').style.display = 'grid';
    document.querySelector('.cartWishlistCountD').innerHTML = cartSelectCounter;
  }
}

function closeSelected_CartItems() {
  if (isCartLargeDesktopViewport) {
    setTimeout(() => {
      document.querySelector('body').classList.remove('overflow-hidden');
    })
  }

  if (isCartMobileViewport && document.querySelector('cart-drawer.drawer.active') ) {
    document.querySelector('.wishlistDelete_MobModal').style.transform = 'translateY(80vh)';
    document.querySelector('.overlayDiv').style.display = 'none';
    setTimeout(() => {
      document.querySelector('.wishlistDelete_MobModal').classList.remove('wishlistMobModal');
    }, 300);
  } else {
    document.querySelector('.overlayDiv_Desk').style.animation = 'opacityFade 0.5s forwards';
    document.querySelector('.wishlistDelete_DeskModal').style.animation = 'opacityFade 0.5s forwards';
    setTimeout(() => {
      document.querySelector('.overlayDiv_Desk').style.display = 'none';
      document.querySelector('.wishlistDelete_DeskModal').style.display = 'none';
      document.querySelector('.overlayDiv_Desk').style.animation = 'opacityTrans 0.5s forwards';
      document.querySelector('.wishlistDelete_DeskModal').style.animation = 'opacityTrans 0.5s forwards';
      document.querySelector('.wishlistDelete_DeskModal').classList.remove('wishlistDeskModal');
    }, 500);
  }

  if (document.querySelectorAll('.cartItem_SelectIcon.selectedDelete').length != 0) {
    document.querySelectorAll('.cartItem_SelectIcon.selectedDelete').forEach((e) => {
      e.classList.remove('selectedDelete');
    });

    selectCartItemsArr.length = 0;
    cartSelectCounter = 0;
  }
}

let deleteArr = [];

async function removeCartItems(event, gtmEvent = 'remove_from_cart') {
  if (event.classList.contains('removeItemsCartD')) {
    document.querySelector('.removeItemsCartD .loading-overlay__spinner').classList.remove('hidden');
  } else if (event.classList.contains('removeItemsCart')) {
    document.querySelector('.removeItemsCart .loading-overlay__spinner').classList.remove('hidden');
  }

  deleteArr = selectCartItemsArr.reduce((obj, itemId) => {
    obj[itemId] = 0;
    return obj;
  }, {});

  await deleteSelectArr(deleteArr, gtmEvent);
  await updatePackCart();

  const cartItemCount = parseInt(document.querySelector('[data-cartitemcount]')?.getAttribute('data-cartitemcount'));
  if (
    cartItemCount ==
    selectCartItemsArr.length
  ) {
    document.querySelector('cart-drawer').classList.add('is-empty');
    const customerId = window.clearCartCustomerId;
    const clearLatestCartTokenEndPt = window.clearLatestCartToken;
    if (customerId && clearLatestCartTokenEndPt) {
      await fetch(`${clearLatestCartTokenEndPt}${customerId}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
    }
  }

  if (event.classList.contains('removeItemsCartD') || event.classList.contains('removeItemsCart')) {
    document.querySelector('.removeItemsCartD .loading-overlay__spinner').classList.add('hidden');
  }

  if (
    parseInt(document.querySelector('[data-cartItemCount]')?.getAttribute('data-cartitemcount')) ==
    selectCartItemsArr.length
  ) {
    document.querySelector('cart-drawer').classList.add('is-empty');
  }

  document.querySelector('.close_WishlistDelete_ModalD').click();
  // document.querySelector('body').classList.remove('overflow-hidden');

  cartTemplate = document.querySelector('[cartTemplate]').getAttribute('cartTemplate');
  if (cartTemplate == 'product') {
    variantsArr.forEach((e) => {
      selectCartItemsArr.forEach((y) => {
        if (e.id == y) {
          e.cartQty = '0';
        }
      });
    });
  }

  selectCartItemsArr.length = 0;
  deleteArr = [];

  //If a variant deleted from the cart then the ATC button should be updated from view cart to Add to Bag
  let checkedVariantLabel = document.querySelector(".variant_innerWrapper input[type=radio]:checked+label");
  if(checkedVariantLabel){
    checkedVariantLabel.click();
  }

  return 'Item(s) Deleted';
}

async function deleteSelectArr(deleteArr, gtmEvent) {
  let variantBody1 = {
    updates: deleteArr,
  };

  let requestOptions1 = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify(variantBody1),
  };

  try {
    let response = await fetch('/cart/update.js', requestOptions1);
    let responseJSON = await response.json();
    if( typeof updateDeletedVariants === 'function' ) updateDeletedVariants(deleteArr);
    let itemCount = responseJSON.item_count;
    let cartTotal = Number((responseJSON.total_price / 100).toFixed(2)) || 0;

    if ( typeof updateGtmForMatchingItems === 'function' && gtmEvent && itemCount != null && cartTotal != null && deleteArr != null ) {
      updateGtmForMatchingItems({
        matchCondition: (itemId) => itemId && deleteArr.hasOwnProperty(itemId),
        eventName: gtmEvent,
        itemCount,
        cartTotal
      });
    }

    return 'done';
  } catch (err) {
    document.querySelector('.removeItemsCartD .loading-overlay__spinner').classList.add('hidden');
    throw err;
  }
}

async function moveToWishlist(event) {
  if (event.classList.contains('moveToWishlistD')) {
    document.querySelector('.moveToWishlistD .loading-overlay__spinner').classList.remove('hidden');
  } else {
    document.querySelector('.moveToWishlist .loading-overlay__spinner').classList.remove('hidden');
  }

  document.querySelectorAll('.cartItem_SelectIcon.selected').forEach((e) => {
    e.parentElement.nextElementSibling.querySelector('.addToWishlist').click();
  });

  document.querySelectorAll('.cartItem_SelectIcon.selectedDelete').forEach((e) => {
    e.parentElement.nextElementSibling.querySelector('.addToWishlist').click();
  });

  await removeCartItems(event,'move_to_wishlist');

  if (event.classList.contains('moveToWishlistD')) {
    document.querySelector('.moveToWishlistD .loading-overlay__spinner').classList.add('hidden');
  } else {
    document.querySelector('.moveToWishlist .loading-overlay__spinner').classList.add('hidden');
  }

  let cartTemplate = document.querySelector('[cartTemplate]').getAttribute('cartTemplate');

  if (cartTemplate == 'account') {
    if (isCartTabletOrDesktopViewport) {
      wishlist();
    } else {
      wishlistM();
    }
  }
}

/*
  ┌─────────────────────────────────────────────────────────────────────────┐
  │  Cart to Wishlist/Delete                                                │
  │  If the user clicks outside the modal, then the modal should close.     │
  │  This function is for both dekstop and modal pop up                     │
  └─────────────────────────────────────────────────────────────────────────┘
*/

function overlayCloseModal(event) {
  if (event.classList.contains('wishlistDelete_DeskModal') || event.classList.contains('wishlistDelete_MobModal')) {
  } else {
    closeSelected_CartItems();
  }
}

let wishlistModalTouchStartPosition;
wishlistBarClose();

function wishlistBarClose() {
  document
    .querySelector('[wishlist-barclose="wishlistModalclose"]')
    .addEventListener('touchstart', wishlistModalBartoCloseTouchStartHandler, { passive: true });

  document
    .querySelector('[wishlist-barclose="wishlistModalclose"]')
    .addEventListener('touchend', wishlistModalBartoCloseTouchEndHandler, { passive: true });

  document
    .querySelector('[wishlist-barclose="wishlistModalclose"]')
    .addEventListener('touchmove', wishlistModalBartoCloseTouchMoveHandler, { passive: true });
}

function wishlistModalBartoCloseTouchStartHandler(event) {
  let bar_touch = event.touches[0];
  wishlistModalTouchStartPosition = bar_touch.clientY;
}

function wishlistModalBartoCloseTouchMoveHandler(event) {
  if (wishlistModalTouchStartPosition !== undefined) {
    let bar_touch = event.touches[0];
    let deltaY1 = bar_touch.clientY - wishlistModalTouchStartPosition;
    if (deltaY1 > 60) {
      // User has dragged down enough to close the modal
      closeSelected_CartItems();
    }
  }
}

function wishlistModalBartoCloseTouchEndHandler(event) {
  wishlistModalTouchStartPosition = undefined;
}

function delete_wishlist_item(event) {
  document.querySelector('.icon-selectAll-active-span').click();
  selectCartItemsArr.length = 0;
  selectCartItemsArr.push(event.getAttribute('data-delete-variant-id'));
  event.parentElement.previousElementSibling.querySelector('.cartItem_SelectIcon').classList.add('selectedDelete');
  cartSelectCounter = 1;
  delCartItems_Modal();
}
